import React, { useState } from 'react';
import {
  Mail, MessageSquare, Globe, Linkedin, Instagram, Facebook,
  User, Phone, ChevronRight, Download, Check, MapPin, Contact, Briefcase
} from 'lucide-react';
import { cardProfile, cardLinks } from '../data/cardData';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/* ── Brand icon SVGs for services without lucide equivalents ── */

const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const SnapchatIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12.959-.289.105-.06.21-.09.3-.09.22 0 .39.12.42.24.075.195-.135.495-.33.585-.28.135-.765.345-1.23.345a1.75 1.75 0 01-.345-.03c-.135 0-.315.015-.435.06-.18.06-.27.18-.24.36.12.585.63 2.175 2.34 2.97.18.09.225.18.225.24 0 .22-.45.39-.69.45-.315.075-.585.12-.78.24-.12.075-.165.195-.15.33.015.12.09.375.09.465 0 .225-.12.39-.39.39h-.06c-.27-.015-.645-.165-1.17-.165-.09 0-.195 0-.285.015-.69.06-1.17.585-2.235.585-1.02 0-1.785-.525-2.445-.585h-.03c-.135 0-.255.015-.345.015-.42 0-.87.135-1.17.165-.135.015-.18.015-.255.015-.255 0-.36-.18-.375-.39 0-.09.06-.33.09-.465.015-.135-.03-.255-.15-.33-.195-.12-.465-.165-.78-.24-.24-.06-.69-.225-.69-.45 0-.06.045-.15.225-.24 1.71-.795 2.22-2.385 2.34-2.97.03-.18-.06-.3-.24-.36a1.17 1.17 0 00-.435-.06c-.15.015-.345.03-.525.03h-.06c-.39 0-.84-.18-1.17-.33-.24-.12-.36-.33-.33-.495.03-.135.21-.24.435-.24.075 0 .15.015.255.06.27.135.6.24.93.27h.06c.23 0 .36-.06.42-.105l-.018-.18c-.015-.21-.03-.42-.045-.645-.105-1.62-.225-3.645.3-4.83C7.845 1.07 11.247.793 12.206.793"/>
  </svg>
);

const SpotifyIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const SoundCloudIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c0-.057-.045-.1-.09-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.165 1.308c0 .055.045.094.099.094.051 0 .09-.038.09-.094l.2-1.308-.2-1.332c0-.057-.04-.094-.09-.094m1.83-1.229c-.063 0-.12.045-.12.104l-.21 2.563.225 2.458c0 .06.045.104.105.104.074 0 .12-.044.12-.104l.24-2.458-.24-2.563c0-.06-.03-.104-.12-.104m.945-.089c-.075 0-.135.06-.15.135l-.193 2.64.21 2.544c.016.077.075.135.15.135.074 0 .135-.058.15-.135l.24-2.544-.24-2.64c-.015-.09-.076-.135-.15-.135m1.155.36c-.005-.09-.075-.149-.155-.149s-.15.06-.164.149l-.217 2.43.2 2.563c.014.09.074.149.163.149.075 0 .15-.06.164-.149l.227-2.563-.218-2.43m.809-1.709c-.09 0-.18.09-.18.18l-.21 3.957.187 2.563c0 .09.09.18.18.18s.165-.09.18-.18l.21-2.563-.21-3.957c-.015-.09-.09-.18-.18-.18m.959-.914c-.105 0-.195.09-.21.195l-.165 4.706.18 2.535c.015.105.105.18.21.18.094 0 .189-.075.21-.18l.195-2.535-.21-4.706c-.015-.105-.105-.195-.21-.195m1.035.45c-.015-.12-.12-.21-.24-.21-.105 0-.21.09-.225.21l-.18 4.29.18 2.535c.015.12.12.21.24.21.105 0 .21-.09.225-.21l.195-2.535-.195-4.29m.99-.555c-.03-.135-.135-.225-.27-.225-.15 0-.255.09-.27.225l-.165 4.41.165 2.25c.015.15.12.24.27.24.135 0 .24-.09.27-.24l.18-2.25-.18-4.41m2.04-.6c-.045-.165-.18-.285-.36-.285-.165 0-.315.12-.345.285L9 14.46l.165 2.22c.03.165.18.285.345.285.165 0 .315-.12.345-.285l.195-2.22-.21-5.88m1.08-.18c-.045-.18-.195-.3-.39-.3-.18 0-.33.12-.375.3l-.18 5.88.165 2.19c.03.18.195.3.39.3.18 0 .33-.12.375-.3l.195-2.19-.18-5.88m.96-.225c-.195 0-.375.15-.39.345l-.165 5.88.18 2.16c.015.195.195.345.375.345.195 0 .375-.15.39-.345l.18-2.16-.18-5.88c-.015-.195-.195-.345-.39-.345m3.135 1.755c-.27 0-.54.03-.81.09-.165-1.83-1.725-3.255-3.615-3.255-.465 0-.915.09-1.32.24a.594.594 0 00-.255.21v6.48c.015.12.105.225.24.24h5.76c1.14 0 2.07-.93 2.07-2.07 0-1.11-.93-2.04-2.07-2.04"/>
  </svg>
);

const VenmoIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M19.77 2.28c.75 1.22 1.09 2.48 1.09 4.07 0 5.07-4.33 11.66-7.84 16.29H5.55L2.14 3.12l7.01-.67 1.7 13.71c1.59-2.6 3.55-6.67 3.55-9.44 0-1.52-.26-2.56-.67-3.41l5.94-1.03z"/>
  </svg>
);

const TextIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
    <circle cx="8" cy="10" r="1.2"/>
    <circle cx="12" cy="10" r="1.2"/>
    <circle cx="16" cy="10" r="1.2"/>
  </svg>
);

const ContactCardIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/>
    <circle cx="10" cy="11" r="2.5"/>
    <path d="M10 14.5c-2 0-4 1-4 2.5h8c0-1.5-2-2.5-4-2.5z"/>
    <path d="M15 9h4v1.5h-4zm0 3h3v1.5h-3z"/>
  </svg>
);

/* ── Icon + color mapping ── */

const iconComponents = {
  'message-square': TextIcon,
  'contact': ContactCardIcon,
  'discord': DiscordIcon,
  'mail': Mail,
  'globe': Globe,
  'linkedin': Linkedin,
  'instagram': Instagram,
  'facebook': Facebook,
  'snapchat': SnapchatIcon,
  'spotify': SpotifyIcon,
  'soundcloud': SoundCloudIcon,
  'venmo': VenmoIcon,
};

const tileStyles = {
  'message-square': { bg: 'linear-gradient(135deg, #43E97B, #38F9D7)', color: '#fff' },
  'contact':        { bg: 'linear-gradient(135deg, #C4C4C4, #9E9E9E)', color: '#555' },
  'discord':        { bg: '#5865F2', color: '#fff' },
  'mail':           { bg: 'linear-gradient(135deg, #1E90FF, #00BFFF)', color: '#fff' },
  'globe':          { bg: 'linear-gradient(135deg, #f0f0f0, #e0e0e0)', color: '#007AFF' },
  'linkedin':       { bg: '#0A66C2', color: '#fff' },
  'instagram':      { bg: 'linear-gradient(135deg, #F58529, #DD2A7B, #8134AF, #515BD4)', color: '#fff' },
  'facebook':       { bg: '#1877F2', color: '#fff' },
  'snapchat':       { bg: '#FFFC00', color: '#000' },
  'spotify':        { bg: '#191414', color: '#1DB954' },
  'soundcloud':     { bg: '#FF5500', color: '#fff' },
  'venmo':          { bg: '#008CFF', color: '#fff' },
};

const COUNTRY_CODES = [
  { code: '+1', flag: '\u{1F1FA}\u{1F1F8}', label: 'US' },
  { code: '+1', flag: '\u{1F1E8}\u{1F1E6}', label: 'CA' },
  { code: '+44', flag: '\u{1F1EC}\u{1F1E7}', label: 'UK' },
  { code: '+61', flag: '\u{1F1E6}\u{1F1FA}', label: 'AU' },
  { code: '+49', flag: '\u{1F1E9}\u{1F1EA}', label: 'DE' },
  { code: '+33', flag: '\u{1F1EB}\u{1F1F7}', label: 'FR' },
  { code: '+91', flag: '\u{1F1EE}\u{1F1F3}', label: 'IN' },
  { code: '+81', flag: '\u{1F1EF}\u{1F1F5}', label: 'JP' },
  { code: '+86', flag: '\u{1F1E8}\u{1F1F3}', label: 'CN' },
  { code: '+55', flag: '\u{1F1E7}\u{1F1F7}', label: 'BR' },
  { code: '+52', flag: '\u{1F1F2}\u{1F1FD}', label: 'MX' },
  { code: '+82', flag: '\u{1F1F0}\u{1F1F7}', label: 'KR' },
  { code: '+39', flag: '\u{1F1EE}\u{1F1F9}', label: 'IT' },
  { code: '+34', flag: '\u{1F1EA}\u{1F1F8}', label: 'ES' },
  { code: '+31', flag: '\u{1F1F3}\u{1F1F1}', label: 'NL' },
  { code: '+46', flag: '\u{1F1F8}\u{1F1EA}', label: 'SE' },
  { code: '+47', flag: '\u{1F1F3}\u{1F1F4}', label: 'NO' },
  { code: '+41', flag: '\u{1F1E8}\u{1F1ED}', label: 'CH' },
  { code: '+48', flag: '\u{1F1F5}\u{1F1F1}', label: 'PL' },
  { code: '+351', flag: '\u{1F1F5}\u{1F1F9}', label: 'PT' },
  { code: '+353', flag: '\u{1F1EE}\u{1F1EA}', label: 'IE' },
  { code: '+65', flag: '\u{1F1F8}\u{1F1EC}', label: 'SG' },
  { code: '+971', flag: '\u{1F1E6}\u{1F1EA}', label: 'AE' },
  { code: '+972', flag: '\u{1F1EE}\u{1F1F1}', label: 'IL' },
  { code: '+27', flag: '\u{1F1FF}\u{1F1E6}', label: 'ZA' },
  { code: '+234', flag: '\u{1F1F3}\u{1F1EC}', label: 'NG' },
  { code: '+63', flag: '\u{1F1F5}\u{1F1ED}', label: 'PH' },
  { code: '+66', flag: '\u{1F1F9}\u{1F1ED}', label: 'TH' },
  { code: '+84', flag: '\u{1F1FB}\u{1F1F3}', label: 'VN' },
  { code: '+62', flag: '\u{1F1EE}\u{1F1E9}', label: 'ID' },
  { code: '+60', flag: '\u{1F1F2}\u{1F1FE}', label: 'MY' },
  { code: '+64', flag: '\u{1F1F3}\u{1F1FF}', label: 'NZ' },
  { code: '+7', flag: '\u{1F1F7}\u{1F1FA}', label: 'RU' },
  { code: '+90', flag: '\u{1F1F9}\u{1F1F7}', label: 'TR' },
  { code: '+54', flag: '\u{1F1E6}\u{1F1F7}', label: 'AR' },
  { code: '+56', flag: '\u{1F1E8}\u{1F1F1}', label: 'CL' },
  { code: '+57', flag: '\u{1F1E8}\u{1F1F4}', label: 'CO' },
  { code: '+20', flag: '\u{1F1EA}\u{1F1EC}', label: 'EG' },
  { code: '+254', flag: '\u{1F1F0}\u{1F1EA}', label: 'KE' },
  { code: '+1876', flag: '\u{1F1EF}\u{1F1F2}', label: 'JM' },
];

const Card = () => {
  const [step, setStep] = useState('form');
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', notes: '' });
  const [countryCode, setCountryCode] = useState('+1');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [savedContact, setSavedContact] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    // Get location (non-blocking — send without it if denied/unavailable)
    let location = null;
    try {
      const pos = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000 });
      });
      location = { lat: pos.coords.latitude, lng: pos.coords.longitude };
    } catch (_) { /* location denied or unavailable */ }

    try {
      await axios.post(`${API}/card/contact`, {
        ...formData,
        phone: countryCode + formData.phone.replace(/\D/g, ''),
        location
      });
      setStep('links');
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const downloadVCard = async () => {
    try {
      const response = await axios.get(`${API}/card/vcard`, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'text/vcard' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Peter_McGraw.vcf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setSavedContact(true);
    } catch (err) {
      console.error('Error downloading vCard:', err);
    }
  };

  const handleLinkClick = (e, link) => {
    if (link.type === 'vcard') {
      e.preventDefault();
      downloadVCard();
    }
    // 'action' type (sms) and regular links use default <a> behavior
  };

  const handleSkip = () => setStep('links');

  const renderLinkGrid = () => (
    <div className="grid grid-cols-3 gap-3" data-testid="card-links-list">
      {cardLinks.map((link, index) => {
        const Icon = iconComponents[link.icon] || Globe;
        const style = tileStyles[link.icon] || { bg: '#333', color: '#52ff00' };
        return (
          <a
            key={index}
            href={link.url}
            target={link.type === 'link' ? '_blank' : undefined}
            rel={link.type === 'link' ? 'noopener noreferrer' : undefined}
            onClick={(e) => handleLinkClick(e, link)}
            className="flex flex-col items-center gap-2.5 group"
            data-testid={`card-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div
              className="w-20 h-20 rounded-[22px] flex items-center justify-center shadow-lg transition-transform group-hover:scale-105 group-active:scale-95"
              style={{ background: style.bg, color: style.color }}
            >
              <Icon />
            </div>
            <span className="text-[11px] font-semibold text-gray-400 group-hover:text-white transition-colors text-center leading-tight max-w-[80px]">
              {link.name}
            </span>
          </a>
        );
      })}
    </div>
  );

  return (
    <div className="min-h-screen bg-black text-white flex flex-col" data-testid="card-page">
      {/* Banner */}
      <div className="relative">
        <div className="h-32 w-full relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-lime-500/30 via-black to-lime-500/10"></div>
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 8px, rgba(82, 255, 0, 0.04) 8px, rgba(82, 255, 0, 0.04) 16px)'
          }}></div>
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent"></div>
        </div>

        {/* Profile */}
        <div className="flex flex-col items-center -mt-16 relative z-10">
          <div className="relative">
            <div className="absolute inset-0 bg-lime-500 rounded-full blur-2xl opacity-20 scale-125"></div>
            <div className="relative w-32 h-32 rounded-full overflow-hidden shadow-2xl ring-4 ring-lime-500 ring-offset-4 ring-offset-black">
              <img
                src={cardProfile.image}
                alt={cardProfile.name}
                className="w-full h-full object-cover object-center scale-125"
                data-testid="card-profile-image"
              />
            </div>
          </div>

          <h1 className="text-2xl font-black uppercase tracking-wide text-white mt-4" data-testid="card-profile-name">
            {cardProfile.name}
          </h1>
          <p className="text-sm font-bold text-lime-500 mt-1" data-testid="card-profile-title">
            {cardProfile.title}
          </p>
          <p className="text-sm font-semibold text-gray-400">{cardProfile.company}</p>
          <div className="flex items-center gap-1.5 mt-2 text-gray-500">
            <MapPin className="w-3 h-3" />
            <span className="text-xs tracking-wide">{cardProfile.location}</span>
          </div>
          <p className="text-xs text-gray-400 mt-3 text-center max-w-xs leading-relaxed px-4">
            {cardProfile.bio}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full max-w-md mx-auto px-5 pt-6 pb-8 flex-1">
        {step === 'form' ? (
          <div data-testid="card-contact-form-section">
            <div className="flex items-center gap-3 mb-5">
              <div className="flex-1 h-px bg-gray-800"></div>
              <span className="text-xs text-gray-500 uppercase tracking-widest font-bold">Share your info</span>
              <div className="flex-1 h-px bg-gray-800"></div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-3" data-testid="card-contact-form">
              <div className="relative">
                <User className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Full name"
                  className="w-full bg-gray-900/80 border border-gray-800 focus:border-lime-500 rounded-lg text-white pl-11 pr-4 py-3 outline-none transition-all text-sm font-medium"
                  data-testid="card-input-name" />
              </div>
              <div className="flex gap-0">
                <select
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  className="bg-gray-900/80 border border-gray-800 border-r-0 focus:border-lime-500 rounded-l-lg text-white pl-2 pr-1 py-3 outline-none text-sm font-medium appearance-none cursor-pointer"
                  style={{ minWidth: '72px' }}
                  data-testid="card-country-code"
                >
                  {COUNTRY_CODES.map((c, i) => (
                    <option key={i} value={c.code}>{c.flag} {c.code}</option>
                  ))}
                </select>
                <div className="relative flex-1">
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="Phone number"
                    className="w-full bg-gray-900/80 border border-gray-800 focus:border-lime-500 rounded-r-lg text-white pl-3 pr-4 py-3 outline-none transition-all text-sm font-medium"
                    data-testid="card-input-phone" />
                </div>
              </div>
              <div className="relative">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email (optional)"
                  className="w-full bg-gray-900/80 border border-gray-800 focus:border-lime-500 rounded-lg text-white pl-11 pr-4 py-3 outline-none transition-all text-sm font-medium"
                  data-testid="card-input-email" />
              </div>
              <div className="relative">
                <Briefcase className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Company (optional)"
                  className="w-full bg-gray-900/80 border border-gray-800 focus:border-lime-500 rounded-lg text-white pl-11 pr-4 py-3 outline-none transition-all text-sm font-medium"
                  data-testid="card-input-company" />
              </div>
              <div className="relative">
                <MessageSquare className="absolute left-3.5 top-3.5 w-4 h-4 text-gray-500" />
                <textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Notes (optional)" rows={3}
                  className="w-full bg-gray-900/80 border border-gray-800 focus:border-lime-500 rounded-lg text-white pl-11 pr-4 py-3 outline-none transition-all text-sm font-medium resize-none"
                  data-testid="card-input-notes" />
              </div>

              {error && (
                <div className="bg-red-900/30 border border-red-500/50 text-red-400 px-4 py-2 text-sm text-center rounded-lg" data-testid="card-form-error">
                  {error}
                </div>
              )}

              <button type="submit" disabled={isSubmitting}
                className="w-full bg-gray-800 border border-gray-700 hover:border-lime-500 text-white py-3 rounded-full font-bold uppercase tracking-wider text-sm transition-all transform hover:scale-[1.02] active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                data-testid="card-submit-button"
              >
                {isSubmitting ? 'Connecting...' : 'Connect'}
                {!isSubmitting && <ChevronRight className="w-4 h-4" />}
              </button>
            </form>

            <button onClick={handleSkip}
              className="w-full text-gray-600 hover:text-gray-400 text-xs uppercase tracking-wider mt-3 py-2 transition-colors font-bold"
              data-testid="card-skip-button"
            >
              Skip to links
            </button>
          </div>
        ) : (
          <div data-testid="card-links-section">
            {/* Save Contact pill */}
            <button onClick={downloadVCard}
              className={`w-full ${savedContact ? 'bg-gray-900 ring-1 ring-lime-500' : 'bg-lime-500 shadow-lg shadow-lime-500/20'} ${savedContact ? 'text-lime-500' : 'text-black'} py-3.5 rounded-full font-black uppercase tracking-wider text-sm transition-all transform hover:scale-[1.02] active:scale-95 flex items-center justify-center gap-2 mb-8`}
              data-testid="card-save-contact-button-links"
            >
              {savedContact ? <><Check className="w-4 h-4" /> Contact Saved</> : <><Download className="w-4 h-4" /> Save Contact</>}
            </button>

            {renderLinkGrid()}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="w-full max-w-md mx-auto px-5 pb-6">
        <div className="h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent mb-4"></div>
        <a href="/" className="block text-center text-[10px] text-gray-700 uppercase tracking-widest font-bold hover:text-gray-500 transition-colors">petemcgraw.com</a>
      </div>
    </div>
  );
};

export default Card;
